<template>
  <div class="scam-page">
    <div class="scam-warning-stripe" role="alert">
      <span class="scam-warning-icon" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
          <path d="M12 2L1 21h22L12 2zm0 4.83L19.53 19H4.47L12 6.83zM11 10v5h2v-5h-2zm0 6v2h2v-2h-2z"/>
        </svg>
      </span>
      <span>Wichtiger Hinweis – bitte vollständig lesen</span>
    </div>

    <main class="scam-container">
      <header class="scam-header">
        <h1 class="scam-title">Sie sind hier nicht richtig.</h1>
        <p class="scam-lead">
          Sie wurden über eine <strong>betrügerische Internetseite</strong> auf diese
          Webseite weitergeleitet. Wir möchten Ihnen helfen, jetzt die richtigen Schritte
          zu gehen.
        </p>
      </header>

      <section class="scam-section">
        <h2>Was ist passiert?</h2>
        <p>
          Unbekannte Betrüger nutzen den Namen unseres Fitnessstudios, um Menschen im
          Internet zu täuschen. Nach der Zahlung an die Betrüger werden die Opfer auf
          unsere echte Studio-Webseite umgeleitet. So entsteht der falsche Eindruck, das
          Studio stecke hinter dem Betrug.
        </p>
        <p>
          Das <strong>DailyFit Oberviechtach</strong> ist ein lokales Fitnessstudio in
          Oberviechtach in der Oberpfalz. Wir stehen in
          <strong>keinerlei Verbindung</strong> zu Online-Gewinnspielen, Abo-Fallen,
          Zahlungsaufforderungen oder anderen Angeboten im Internet.
        </p>
        <p>
          Wir können Ihnen leider <strong>kein Geld zurückzahlen</strong>, weil wir
          nichts von Ihnen erhalten haben. Auch wir sind Betroffene dieser Masche.
        </p>
      </section>

      <section class="scam-section scam-steps">
        <h2>Das können Sie jetzt tun</h2>
        <ol>
          <li>
            <div class="step-head">Karte und Konto sofort sperren</div>
          </li>
          <li>
            <div class="step-head">Verbraucherzentrale Bayern kontaktieren</div>
            <p>
              Dort erhalten Sie kostenlose Hilfe und Beratung:<br>
              <a
                href="https://www.verbraucherzentrale-bayern.de/"
                target="_blank"
                rel="noopener noreferrer"
                class="scam-link"
              >www.verbraucherzentrale-bayern.de</a>
            </p>
          </li>
          <li>
            <div class="step-head">Bei Zahlung mit Kreditkarte: Bank anrufen</div>
            <p>
              Bitten Sie Ihre Bank um eine <strong>Rückbuchung (Chargeback)</strong>.
              Bei Betrug ist eine Rückbuchung in den meisten Fällen möglich, wenn Sie
              schnell handeln.
            </p>
          </li>
        </ol>
      </section>

      <section class="scam-notice" role="note">
        <h2>Bitte nicht im Fitnessstudio anrufen</h2>
        <p>
          Wir bekommen viele Anrufe von Betroffenen und möchten ehrlich sein: Wir können
          Ihnen am Telefon nicht weiterhelfen, weil wir mit dem Betrug nichts zu tun
          haben. Bitte wenden Sie sich an die oben genannten Stellen – die helfen Ihnen
          wirklich.
        </p>
      </section>

      <div class="scam-actions">
        <p class="scam-actions-hint">
          Sind Sie zufällig hier gelandet und haben weder etwas bezahlt noch ein
          Abo abgeschlossen? Dann können Sie diese Seite einfach schließen oder
          direkt zur normalen Studio-Webseite wechseln.
        </p>
        <a href="/?legit=1" class="scam-btn-back">
          Zur normalen DailyFit-Startseite
        </a>
      </div>

      <footer class="scam-footer">
        <img
          :src="require('@/assets/logo_ohne_Hintergrund.webp')"
          alt="DailyFit Oberviechtach"
          class="scam-logo"
          width="120"
          height="40"
        />
        <p class="scam-footer-text">
          DailyFit Oberviechtach · Am Bahnhof 2a · 92526 Oberviechtach
        </p>
      </footer>
    </main>
  </div>
</template>

<script>
const ROBOTS_META_ID = 'scam-info-robots-meta'

export default {
  name: 'ScamInfoView',
  mounted() {
    if (!document.getElementById(ROBOTS_META_ID)) {
      const meta = document.createElement('meta')
      meta.id = ROBOTS_META_ID
      meta.name = 'robots'
      meta.content = 'noindex, nofollow'
      document.head.appendChild(meta)
    }

    this._prevTitle = document.title
    document.title = 'Wichtiger Hinweis – DailyFit Oberviechtach'
  },
  beforeUnmount() {
    const meta = document.getElementById(ROBOTS_META_ID)
    if (meta && meta.parentNode) {
      meta.parentNode.removeChild(meta)
    }
    if (this._prevTitle) {
      document.title = this._prevTitle
    }
  },
}
</script>

<style scoped>
.scam-page {
  min-height: 100vh;
  background: #f7f7f5;
  color: #1f2328;
  font-family: 'Outfit', 'Open Sans', system-ui, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.scam-warning-stripe {
  background: #f5b400;
  color: #1f1300;
  padding: 14px 20px;
  font-weight: 600;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  border-bottom: 2px solid #c98a00;
}

.scam-warning-icon {
  display: inline-flex;
  align-items: center;
}

.scam-container {
  max-width: 720px;
  margin: 0 auto;
  padding: 40px 22px 60px;
}

.scam-header {
  text-align: center;
  margin-bottom: 36px;
}

.scam-title {
  font-size: clamp(1.85rem, 5.5vw, 2.6rem);
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 18px;
  color: #1f2328;
  letter-spacing: -0.01em;
}

.scam-lead {
  font-size: 1.125rem;
  line-height: 1.6;
  margin: 0;
  color: #2b2f36;
}

.scam-section {
  background: #ffffff;
  border: 1px solid #e6e7e9;
  border-radius: 12px;
  padding: 24px 22px;
  margin-bottom: 20px;
}

.scam-section h2 {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 14px;
  color: #1f2328;
}

.scam-section p {
  font-size: 1rem;
  line-height: 1.65;
  margin: 0 0 12px;
  color: #2b2f36;
}

.scam-section p:last-child {
  margin-bottom: 0;
}

.scam-steps ol {
  list-style: none;
  counter-reset: scam-step;
  padding: 0;
  margin: 0;
}

.scam-steps li {
  counter-increment: scam-step;
  position: relative;
  padding: 18px 0 18px 56px;
  border-top: 1px solid #eceef0;
}

.scam-steps li:first-child {
  border-top: none;
  padding-top: 4px;
}

.scam-steps li::before {
  content: counter(scam-step);
  position: absolute;
  left: 0;
  top: 16px;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #1f2328;
  color: #fff;
  font-weight: 700;
  font-size: 1.05rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scam-steps li:first-child::before {
  top: 2px;
}

.step-head {
  font-weight: 700;
  font-size: 1.05rem;
  margin-bottom: 6px;
  color: #1f2328;
}

.scam-steps p {
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
  color: #2b2f36;
}

.scam-link {
  color: #b3540e;
  text-decoration: underline;
  word-break: break-word;
}

.scam-link:hover,
.scam-link:focus {
  color: #8a3f08;
}

.scam-link-call {
  font-weight: 700;
  font-size: 1.15rem;
  letter-spacing: 0.02em;
}

.scam-notice {
  background: #fff7e0;
  border: 1px solid #f0d27a;
  border-radius: 12px;
  padding: 22px;
  margin-bottom: 28px;
}

.scam-notice h2 {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 10px;
  color: #5a3d00;
}

.scam-notice p {
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
  color: #3d2a00;
}

.scam-actions {
  text-align: center;
  margin-bottom: 36px;
}

.scam-actions-hint {
  font-size: 0.95rem;
  line-height: 1.55;
  color: #5d6168;
  max-width: 560px;
  margin: 0 auto 18px;
}

.scam-btn-back {
  display: inline-block;
  background: #1f2328;
  color: #ffffff;
  padding: 14px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: background 0.15s ease;
}

.scam-btn-back:hover,
.scam-btn-back:focus {
  background: #353a42;
  color: #ffffff;
}

.scam-footer {
  text-align: center;
  border-top: 1px solid #e6e7e9;
  padding-top: 22px;
  opacity: 0.7;
}

.scam-logo {
  height: 32px;
  width: auto;
  margin-bottom: 10px;
}

.scam-footer-text {
  font-size: 0.85rem;
  color: #5d6168;
  margin: 0;
}

@media (max-width: 520px) {
  .scam-warning-stripe {
    font-size: 0.92rem;
    padding: 12px 14px;
  }

  .scam-container {
    padding: 28px 16px 48px;
  }

  .scam-section,
  .scam-notice {
    padding: 20px 16px;
  }

  .scam-steps li {
    padding-left: 50px;
  }

  .scam-steps li::before {
    width: 34px;
    height: 34px;
    font-size: 1rem;
  }

  .scam-btn-back {
    display: block;
    width: 100%;
  }
}
</style>
